// extracted by mini-css-extract-plugin
module.exports = {"container":"MarketingPreferences_container__13tou","maxWidthWrapper":"MarketingPreferences_maxWidthWrapper__24w8s","checkbox":"MarketingPreferences_checkbox__1D4fA"};